import React from 'react';
import htmlDecode from '../helpers/htmlDecode';

const SearchOptionsGroup = ({ options, handleRemoveFilter }) => {
  return options
    ? options.map(({ one_liner, remove_params }, index) => {
        const oneLiner = htmlDecode(one_liner);
        return (
          <li key={index} className="active-filters__filter">
            <a
              href={`#active-filter${index}`}
              className="active-filters__filter-link"
              onClick={(event) => handleRemoveFilter(event, remove_params)}
            >
              <span>{oneLiner}</span>
              <i className="far fa-times" aria-hidden="true"></i>
            </a>
          </li>
        );
      })
    : null;
};

const CurrentSearchOptions = ({ searchOptions, handleRemoveFilter }) => {
  const options = searchOptions
    ? searchOptions.map((group, key) => {
        if (group.group_name.match(/What|Where|Include|Inclure/i)) {
          return null;
        }
        return (
          <section className="active-filters__group" key={key}>
            <h4 className="active-filters__title">{group.group_name}</h4>
            <ul>
              <SearchOptionsGroup
                options={group.group_options}
                handleRemoveFilter={handleRemoveFilter}
              />
            </ul>
          </section>
        );
      })
    : null;

  return <div className="active-filters">{options}</div>;
};

export default CurrentSearchOptions;
